import { useEffect } from 'react';

/**
 * Global keyboard shortcut: ⌘K on macOS, Ctrl+K elsewhere. Mirrors the convention
 * used by VSCode, Linear, Notion, etc. — discoverable via the search-trigger
 * button in the topbar (which displays the kbd hint).
 */
export function useCommandPaletteShortcut(open: () => void) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      const mod = e.metaKey || e.ctrlKey;
      if (mod && (e.key === 'k' || e.key === 'K')) {
        e.preventDefault();
        open();
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [open]);
}
